// extracted by mini-css-extract-plugin
module.exports = {"techStack":"TechStack_techStack__2v5G3","list":"TechStack_list__tEO5v","tech":"TechStack_tech__2-WLF","name":"TechStack_name__DEaJV"};